(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/prescript.js'); 
var svs = svs || {};
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service = svs.customer_service || {};

  svs.customer_service.app = new Backbone.Marionette.Application({
    region: '#help',

    onStart: function() {
      svs.customer_service_logger = new svs.core.log.Logger('module:customer-service');
      svs.customer_service.models.contact = new svs.customer_service.models.Contact();
      svs.customer_service.router = new svs.customer_service.Router();
      Backbone.history.start({ pushState: true, root: svs.core.data.baseUrl });
    }
  });

  svs.customer_service.data = svs.customer_service.data || {};
  svs.customer_service.views = svs.customer_service.views || {};
  svs.customer_service.models = svs.customer_service.models || {};
  svs.customer_service.router = svs.customer_service.router || {};
})(Backbone, _, svs);

 })(window);